import React, {useState, useRef}  from 'react'
import styled from "styled-components";
import { Map, Marker, ZoomControl } from 'pigeon-maps'
import { osm } from 'pigeon-maps/providers'
import {FaEnvelope, FaLink, FaPhone} from "react-icons/fa6";
import { Main, AboutBody, AboutBox, TextBox } from './commonStyles';
import SafeTextToHTML from "../components/SafeTextToHTML";
import ReCAPTCHA from 'react-google-recaptcha'

export const GridContainer1 = styled.div `
    display: grid;
    grid-template-columns: 100%;
    justify-content: start;
    gap: 10px;
`;

export const GridContainer2 = styled.div `
    display: grid;
    grid-template-columns: auto auto;
    justify-content: start;
    gap: 10px;
    padding-top: 20px
`;

export const Button = styled.button`
  border-radius:15px;
  color: black;
`;

export async function PostMessage(path, Message) {
    const url = new URL(path);
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                },
            body: JSON.stringify(Message)
        });
        const json = await response.json();
        return json;
    } catch(e) {
        console.log('POST call failed: ' + path + ' : ' + JSON.stringify(Message) + ' : ', e)
        return {'Error': 'POST Call failed: '}  
    }

}


export default function About({content, smallWindow, windowSize}) {

    const [email, setEmail] = useState({Domain: content.DomainID, Name:'', Email: '', Message: '', Captcha: ''});
    const [emailSubmitted, setEmailSubmitted] = useState(false);
    const [submitValid, setSubmitValid] = useState(false);

    const reCaptchaKey = '6LdpsW0sAAAAADPP76BNKq7J5oMuf4R2RzBxT2Bz'
    const recaptcha = useRef()
    
    const handleChange = e => {
        const { name, value } = e.target;
        setEmail(prevState => ({...prevState, [name]: value}));
        if (email.Email.length > 5 && email.Message.length > 10) {
            setSubmitValid(true)
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        email.captchaValue = recaptcha.current.getValue()
        if (!email.captchaValue) {
            alert('Please verify the reCAPTCHA!')
        } else {
            const submitResponse = await PostMessage(content.about.apiEndpoint, email);
            if ('Error' in submitResponse) {
                // Something went wrong with GetData
                console.log('Submit failed!');
                console.log('Submit Response:', submitResponse.Error);
                alert('Submit failed. Please call or email directly. ' + submitResponse.Error);
            } else {
                setEmailSubmitted(true)
            }
        }
    }

    const latLong = JSON.parse(content.about.latLong);
    const mapHeight = Math.max(windowSize.height/2, 500);

    return (
        <Main content={content.styles}>
            {(smallWindow) ? <h2>&nbsp;{content.about.title}</h2> : null}
            <AboutBody content={{smallWindow: smallWindow}}>
                <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                    <TextBox>
                        <h3>&nbsp;Contact</h3>
                        <p>&nbsp;</p>

                        {(content.about.phone) ? 
                            <>
                                <div style={{color: content.styles.textBoxHighlightColor}}>
                                    <FaPhone/>&nbsp; Phone: &nbsp;
                                    <a href={"tel:" + content.about.phone} style={{color: content.styles.textBoxTextColor}}>{content.about.phone}</a>
                                </div>
                                <p>&nbsp;</p>
                            </> 
                        : null}

                        {(content.about.email) ? 
                            <>
                                <div style={{color: content.styles.textBoxHighlightColor}}>
                                    <FaEnvelope/>&nbsp; Email: &nbsp;
                                    <a href={"mailto:" + content.about.email} style={{color: content.styles.textBoxTextColor}}>{content.about.email}</a>
                                </div>
                                <p>&nbsp;</p>
                            </> 
                        : null}
                        
                        {(content.about.contactInstructions) ? <SafeTextToHTML text={content.about.contactInstructions} /> : ""}
                    </TextBox>
                </AboutBox>
                
                {content.about.getInTouch ? 
                    <AboutBox content={{...content.styles, 'maxBoxWidth': 'Normal'}}>
                        <TextBox>
                            <h3>&nbsp;Get in touch</h3>
                            {!emailSubmitted ? 
                                <>
                                    <GridContainer2>
                                    <label>Name:</label> <input name='Name' type='text' value={email.Name} onChange={handleChange}/>
                                    <label>Email:</label> <input name='Email' type='text' value={email.Email} onChange={handleChange}/>
                                    </GridContainer2>
                                    <GridContainer1>
                                    <label>Message:</label> <></>
                                    <textarea name='Message' rows='10'  value={email.Message} onChange={handleChange} style={{width: '100%'}}/>

                                    {submitValid ? 
                                    <Button onClick={handleSubmit}>Submit</Button>
                                    : 
                                    <Button disabled style={{color: 'grey'}}>Submit</Button>
                                    }
                                    <ReCAPTCHA ref={recaptcha} sitekey={reCaptchaKey} />
                                    </GridContainer1>
                                </>
                            : 
                                <>
                                    <p>&nbsp;</p>
                                    <p>Thank-you for your message</p>
                                </>
                            }
                        </TextBox>
                    </AboutBox>
                : null}

                {(content.about.openingHours && content.about.openingHours.length > 0) ? 
                    <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                        <TextBox>
                            <h3>&nbsp;Opening Times</h3>
                            <p>&nbsp;</p>
                            <SafeTextToHTML text={content.about.openingHours} />
                        </TextBox>
                    </AboutBox>
                : null}

                <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                    <TextBox>
                        <h3>&nbsp;Address</h3>
                        <p>&nbsp;</p>
                        <SafeTextToHTML text={content.about.address} />
                    </TextBox>
                </AboutBox>
                
                {content.about.registrationNumbers && content.about.registrationNumbers.length > 0 ?
                    <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                        <TextBox>
                            <h3>&nbsp;Registration</h3>
                            <p>&nbsp;</p>
                            <SafeTextToHTML text={content.about.registrationNumbers} />
                        </TextBox>
                    </AboutBox>
                                
                : null}

                {(content.about.onlineEnabled) ? 
                    <AboutBox content={{...content.styles, 'maxBoxWidth': 'Narrow'}}>
                        <TextBox>
                            <h3>&nbsp;{content.about.onlineTitle}</h3>
                            <p>&nbsp;</p>
                            <SafeTextToHTML text={content.about.onlineInstructions} />
                            <p>&nbsp;</p>
                            <FaLink style={{color: content.styles.textBoxHighlightColor}}/>&nbsp;
                            <a href={content.about.onlineUrl} style={{color: content.styles.textBoxTextColor}}><u>{content.about.onlineUrlText}</u></a>
                        </TextBox>
                    </AboutBox>
                : null}

                
                <AboutBox content={{...content.styles, 'maxBoxWidth': 'Max'}}>
                    <TextBox>
                        <a href={'https://www.google.com/maps/dir/?api=1&map_action=map&center=' + JSON.stringify(latLong.coord) + '&destination=' + JSON.stringify(latLong.coord)} 
                        style={{color: content.styles.textBoxTextColor}} target="_blank" rel="noopener noreferrer"><u>Click</u> to view directions on Google Maps</a>
                        <p>&nbsp;</p>
                        <div style={{textAlign:'center', border:'1px solid black', height: String(mapHeight) + 'px', width: '100%'}}>
                        <Map key='map' provider={osm} center={latLong.coord} zoom={latLong.zoom} twoFingerDrag={true} metaWheelZoom={true}>
                            {(content.about.mapEnabled) ? <Marker width={50} anchor={latLong.coord} color={'red'}/> : null}
                            <ZoomControl />
                        </Map>
                        </div>
                    </TextBox>
                </AboutBox>
                
            </AboutBody>
            
        </Main>
    )
}

